const settings = {}

if (process.env.NODE_ENV !== 'production' && process.env.NODE_ENV !== 'staging') {
  settings.nodeApi = 'http://frequencylist.local:3000/v2'
  settings.railsApi = 'http://localhost:3000/v2'
  // settings.railsApi = 'http://192.168.0.87:3000/v2'
  // settings.nodeApi = 'http://localhost:8080/api/v2'
} else if (process.env.NODE_ENV === 'staging') {
  settings.nodeApi = 'https://staging.frequencylist.com/v2'
} else {
  settings.nodeApi = 'https://frequencylist.com/v2'
  settings.railsApi = 'https://frequencylist.com/v2'
}

export const nodeApi = settings.nodeApi
export const railsApi = settings.railsApi



// WEBPACK FOOTER //
// ./src/config.js